import React from 'react'
import utils from "../../modules/utils";
import moment from 'moment';
import 'moment/locale/it';
import { connect } from 'react-redux';
import Stepper from '../shared/stepper.js';
import { setModificando, setGiorno, setDove, setTipoAppuntamento, clearHistoryBack, setFlussoModifica, setVecchioAppuntamento } from "../../actions/index";
import { trackPageView } from "../../modules/datalayer.js"
import './typ_clink.css';
/* Flow */
import { goToChangeAppointment } from '../../flow/flow';

const mapDispatchToProps = dispatch => {
  return {
    setFlussoModifica: (fm) => dispatch(setFlussoModifica(fm)),
    setModificando: (m) => dispatch(setModificando(m)),
    setAppointmentType: (type) => dispatch(setTipoAppuntamento(type)),
    setGiorno: (giorno) => dispatch(setGiorno(giorno)),
    setDove: (luogo) => dispatch(setDove(luogo)),
    clearHistoryBack: (c) => dispatch(clearHistoryBack(c)),
    setVecchioAppuntamento: (va) => dispatch(setVecchioAppuntamento(va)),
  }
}

class RiepilogoCLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'nome': '',
      'email': '',
      'codice_fiscale': '',
      'telefono': '',
      'data_appuntamento': '',
      'filiale': '',
      'indirizzo_filiale': '',
      'prodotto': 3
    }
  }

  componentWillMount() {
    const global_state = utils.getState();
    const data_appuntamento = moment(global_state.data_appuntamento + ' ' + global_state.orario_appuntamento).format('dddd DD MMMM');
    const orario = 'ore ' + moment(global_state.data_appuntamento + ' ' + global_state.orario_appuntamento).format('HH:mm');
    this.setState({
      'nome': global_state.utente.nome + ' ' + global_state.utente.cognome,
      'email': global_state.utente.email,
      'codice_fiscale': global_state.utente.codice_fiscale,
      'telefono': global_state.utente.telefono,
      'data_appuntamento': data_appuntamento,
      'orario_appuntamento': orario,
      'filiale': global_state.filiale,
      'indirizzo_filiale': global_state.indirizzo_filiale,
      'prodotto': global_state.prodotto
    });
  }

  componentDidMount() {
    trackPageView('thank-you-page');

    utils.animate.fadeIn();
    utils.animate.slideIn(utils.getState().dati_locali.historyBack);
    this.props.clearHistoryBack();
  }

  render() {
    const { luogo, id_filiale, indirizzo_filiale, dati_locali, prodotto } = utils.getState();
    let filialeScelta;
    if (typeof dati_locali.filiali != 'undefined') {
      filialeScelta = dati_locali.filiali.filiali.find(function (filiale) {
        return filiale.idFiliale === id_filiale;
      });

    }
    return (
      <div id="riepilogo">
        <Stepper percentage="100" />
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell animations-container">
              <div>
                <h2 className="gsap-fade" id="titoloClink">Grazie, abbiamo preso in <br/>carico la tua richiesta</h2>
                <h3 className="gsap-fade">Un nostro consulente ti contatter&agrave; a breve<br/> con un numero di telefono italiano</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(RiepilogoCLink);


// WEBPACK FOOTER //
// ./src/components/thank_you_page_clink/index.js